import type { MessageFunction } from 'vue-i18n';
import homepage from './pages/homepage/index';
import tech from './pages/tech/index';
import statistics from './pages/statistics/index';
import Info from './pages/info/index';
import system from './pages/system/index';
// 希腊
export default {
    license: {
        powered_by: 'SAIC Motor International {\'|\'} Με την επιφύλαξη παντός δικαιώματος',
    },
    auth: {
        login: 'Σύνδεση',
        username: 'Όνομα χρήστη',
        username_placeholder: 'Παρακαλούμε εισάγετε το όνομα χρήστη',
        password: 'Κωδικός πρόσβασης',
        password_placeholder: 'Παρακαλούμε εισάγετε τον κωδικό πρόσβασης',
        code: 'Κωδικός επαλήθευσης',
        code_placeholder: 'Παρακαλούμε εισάγετε τον κωδικό επαλήθευσης',
        logout: 'Αποσύνδεση',
        logout_success: 'Επιτυχής αποσύνδεση',
        day: 'ημέρα',
        password_expiration: 'Ο κωδικός πρόσβασης έχει λήξει – παρακαλούμε αλλάξτε τον',
        expire: 'Απομένουν',
        conseils:
            'Πρέπει να περιλαμβάνει κεφαλαία γράμματα, πεζά γράμματα, αριθμούς και ειδικούς χαρακτήρες ({msg}). Το μήκος του κωδικού πρέπει να είναι 8–16 χαρακτήρες.',
        brand_Selection: 'Επιλογή μάρκας',
        unread_notices: 'Μη αναγνωσμένες ανακοινώσεις',
        new_cases: 'Νέες υποθέσεις',
        unanswered_cases: 'Υποθέσεις χωρίς απάντηση',
        overdue_cases: 'Καθυστερημένες υποθέσεις',
    },
    button: {
        query: 'Αναζήτηση',
        editing_position: 'Επεξεργασία θέσης',
        show_theme_editor: 'Εμφάνιση/Απόκρυψη επεξεργαστή θεμάτων',
        change_password: 'Αλλαγή κωδικού',
        old_password: 'Παλιός κωδικός',
        new_password: 'Νέος κωδικός',
        confirm_password: 'Επιβεβαίωση κωδικού',
        button: 'Κουμπί',
        about: 'Σχετικά',
        back: 'Πίσω',
        go: 'Εντάξει',
        home: 'Αρχική σελίδα',
        confirm: 'Επιβεβαίωση',
        modify: 'Τροποποίηση',
        edit: 'Επεξεργασία',
        new: 'Νέο',
        cancel: 'Ακύρωση',
        close: 'Κλείσιμο',
        search: 'Αναζήτηση',
        reset: 'Επαναφορά',
        delete: 'Διαγραφή',
        add: 'Προσθήκη',
        collapse: 'Σύμπτυξη',
        expand: 'Ανάπτυξη',
        download_template: 'Λήψη προτύπου',
        batch_import: 'Μαζική εισαγωγή',
        import: 'Εισαγωγή',
        export: 'Εξαγωγή',
        export_fail: 'Η εισαγωγή απέτυχε',
        detailed: 'Λεπτομέρειες',
        details: 'Λεπτομέρειες',
        download: 'Λήψη',
        toView: 'Προβολή',
        toViews: 'Προβολή εικόνων',
        uploadAttachments: 'Μεταφόρτωση συνημμένων',
        selectFile: 'Επιλογή αρχείου',
        fillingInstructions: 'Οδηγίες συμπλήρωσης',
        release: 'Δημοσίευση',
        release_recall: 'Ανάκληση δημοσίευσης',
        save: 'Αποθήκευση',
        send: 'Αποστολή',
        tips: 'Συμβουλές',
        send_back: 'Επιστροφή',
        examine: 'Έλεγχος',
        void: 'Ακύρωση',
        more: 'Περισσότερα',
        refresh: 'Ανανέωση',
        selects: 'Παρακαλούμε επιλέξτε',
        serial_number: 'Αριθμός σειράς',
        upload_progress: 'Πρόοδος μεταφόρτωσης',
        invalid: 'Άκυρο',
        daily_record: 'Ημερολόγιο',
        operation_type: 'Τύπος λειτουργίας',
        field_name: 'Όνομα πεδίου',
        edit_role: 'Επεξεργασία ρόλου',
        user_role: 'Επιλογή ρόλου',
        assignment_role: 'Ρόλος',
        post: 'Θέση',
        sending: 'Αποστολή...',
        reset_password: 'Επαναφορά κωδικού',
        display_or_not: 'Εμφάνιση ή όχι',
        document: 'Έγγραφο',
        specificTemplates: 'Συγκεκριμένα πρότυπα',
        transferOrder: 'Μεταφορά παραγγελίας',
        forwarding: 'Προώθηση',
        one_click_notification: 'Γρήγορη ειδοποίηση',
        english_export: 'Εξαγωγή στα αγγλικά',
        oneclick_download: 'Γρήγορη λήψη',
        passwordmsga:
            'Πρέπει να περιλαμβάνει κεφαλαία γράμματα, πεζά γράμματα, αριθμούς και ειδικούς χαρακτήρες (@\\$!_~\\&*)',
        passwordmsgb: 'Το μήκος του κωδικού πρέπει να είναι 8–16 χαρακτήρες',
        passwordmsgc: 'Δεν πρέπει να ταυτίζεται με τους έξι προηγούμενους κωδικούς',
        export_file_list: 'Λίστα εξαγόμενων αρχείων',
        personal_center: 'Προσωπικό κέντρο',
        upload_list: 'Λίστα μεταφορτώσεων',
        clear_completed: 'Καθαρισμός ολοκληρωμένων',
    },
    radio: {
        enabled: 'Ενεργοποιημένο',
        disabled: 'Απενεργοποιημένο',
        catalogue: 'Κατάλογος',
        individual: 'Ατομικό',
        all: 'Όλα',
        yes: 'Ναι',
        no: 'Όχι',
    },
    dropdown: {
        close_others: 'Κλείσιμο άλλων',
        close_right: 'Κλείσιμο δεξιά',
        close_left: 'Κλείσιμο αριστερά',
    },
    table: {
        action: 'Ενέργεια',
        explain: 'Επεξήγηση',
        fileName: 'Όνομα αρχείου',
        size: 'Μέγεθος (MB)',
        uploader: 'Φορτωτής',
        uploadTime: 'Ώρα μεταφόρτωσης',
        system: 'Σύστημα',
        caption: 'Τίτλος',
        categorization: 'Κατηγοριοποίηση',
        link: 'Σύνδεσμος',
        forwarding_time: 'Ώρα προώθησης',
        forwarder: 'Προωθητής',
        send_to: 'Αποστολή σε',
        mode: 'Λειτουργία',
    },
    pagination: {
        pages: ({ named }: Parameters<MessageFunction>[0]) => `${named('number')} / Σελίδα`,
        total: ({ named }: Parameters<MessageFunction>[0]) => `Σύνολο ${named('number')} εγγραφών`,
        vinCount: ({ named }: Parameters<MessageFunction>[0]) =>
            `Σύνολο ${named('number')} οχημάτων`,
    },
    confirm: {
        confirm_deletion: 'Επιβεβαίωση διαγραφής;',
        confirm_void: 'Επιβεβαίωση ακύρωσης;',
        confirm_release: 'Επιβεβαίωση δημοσίευσης;',
        ack: 'Επιβεβαίωση',
        cancel: 'Ακύρωση',
        non_records: 'Παρακαλούμε επιλέξτε τουλάχιστον μία εγγραφή',
    },
    request: {
        failed_placeholder: 'Αποτυχία αιτήματος – σφάλμα διακομιστή',
        success_placeholder: 'Το αίτημα επιτυχής',
        auth: {
            login_success: 'Επιτυχής σύνδεση',
        },
        error: {
            '404': 'Η διαδρομή δεν υπάρχει',
            '403': 'Ανεπαρκή δικαιώματα',
        },
    },
    page: {
        global: {
            page_search: 'Αναζήτηση στη σελίδα',
        },
        error: {
            not_found: 'Η σελίδα δεν βρέθηκε',
            not_found_des: 'Δεν υπάρχει τίποτα εδώ',
            auth_failed: 'Ανεπαρκή δικαιώματα',
            auth_failed_des: 'Η πρόσβαση σε αυτή τη σελίδα απαγορεύεται',
            file_format_error: 'Μη έγκυρη μορφή αρχείου!',
            preview_failed: 'Αποτυχία προεπισκόπησης! Το αρχείο είναι κατεστραμμένο!',
        },
        homepage: {
            homepage: homepage.homepage.elGR,
        },
        system: {
            menu: system.menu.elGR,
            dict: system.dict.elGR,
            dept: system.dept.elGR,
            role: system.role.elGR,
            user: system.user.elGR,
        },
        info: {
            announcement: Info.announcement.announcement.elGR,
            document: Info.document.document.elGR,
        },
        tech: {
            quality: {
                problemTracking: tech.quality.problemTracking.elGR,
                recallActivity: tech.quality.recallActivity.elGR,
                abnormalClaimTracking: tech.quality.abnormalClaimTracking.elGR,
            },
            management: {
                inquiryOd: tech.management.inquiry.elGR,
                permission: tech.management.permission.elGR,
                onSiteSupportHq: tech.management.onSiteSupport.elGR,
                progHistoryHq: tech.management.progHistory.elGR,
                salesRecordHq: tech.management.salesRecord.elGR,
                vehicleInfoHq: tech.management.vehicleInfo.elGR,
                claimHq: tech.management.claim.elGR,
                filterHq: tech.management.filter.elGR,
                newCarlssue: tech.management.newCarIssue.elGR,
                newCarDefinition: tech.management.newCarDefinition.elGR,
                vehicleProductionInfo: tech.management.vehicleProductionInfo.elGR,
                programmingHistoryInformationQuery:
                    tech.management.programmingHistoryInformationQuery.elGR,
                ecuControllerInformationQuery: tech.management.ecuControllerInformationQuery.elGR,
            },
        },
        components: {
            businessComponents: tech.management.businessComponents.elGR,
        },
        statistics: statistics.inquiryStatistics.elGR,
        systemClassifyA: statistics.systemClassifyA.elGR,
        systemClassifyB: statistics.systemClassifyB.elGR,
        engineerStatistics: statistics.engineerStatistics.elGR,
        defectivePart: statistics.defectivePart.elGR,
        replyInquiryStatistics: statistics.replyInquiryStatistics.elGR,
        passRateStatistics: statistics.passRateStatistics.elGR,
        timelyResponseRateStatistics: statistics.timelyResponseRateStatistics.elGR,
        responseRateStatistics24Hour: statistics.responseRateStatistics24Hour.elGR,
        customsClearance135Rate: statistics.customsClearance135Rate.elGR,
        accumulatedClosureRate: statistics.accumulatedClosureRate.elGR,
        engineerAffiliatedOrganization: statistics.engineerAffiliatedOrganization.elGR,
        EngineerResponseRateReport: statistics.EngineerResponseRateReport.elGR,
    },
    validation: {
        common: {
            required: 'Αυτό το πεδίο είναι υποχρεωτικό',
            numeric: 'Πρέπει να είναι ακέραιος αριθμός',
            decimal: 'Πρέπει να είναι αριθμός',
            positive_interger: 'Πρέπει να είναι θετικός ακέραιος',
            up_to_digits: ({ named }: Parameters<MessageFunction>[0]) =>
                `Μέγιστος αριθμός ${named('number')} ψηφίων`,
            more_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Δεν πρέπει να υπερβαίνει τα ${named('number')} χαρακτήρες`,
            max_bytes: ({ named }: Parameters<MessageFunction>[0]) =>
                `Υπερβαίνει το μέγιστο όριο χαρακτήρων (${named('number')})`,
            less_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Τουλάχιστον ${named('number')} χαρακτήρες`,
            must_be_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Πρέπει να είναι ακριβώς ${named('number')} χαρακτήρες`,
            greater_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Δεν πρέπει να είναι μεγαλύτερο από ${named('number')}`,
            less_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Δεν πρέπει να είναι μικρότερο από ${named('number')}`,
            up_to_2_decimal_places: 'Μέγιστο 2 δεκαδικά ψηφία',
            retain_up: 'Μέγιστο 10 ψηφία πριν την υποδιαστολή, έως 2 δεκαδικά',
            retain_ups: 'Μέγιστο 11 ψηφία πριν την υποδιαστολή, έως 4 δεκαδικά',
            input_number: 'Παρακαλούμε εισάγετε αραβικά ψηφία',
            only_number_a: 'Επιτρέπονται μόνο γράμματα ή αριθμοί',
            translate: 'Επιτρέπονται μόνο γράμματα',
            positive_integer: 'Συμπληρώστε τουλάχιστον ένα πεδίο',
            at_least_one: 'Συμπληρώστε τουλάχιστον ένα',
        },
        tip: {
            incomplete_information: 'Οι πληροφορίες δεν έχουν συμπληρωθεί πλήρως',
        },
    },
    import: {
        template_file: 'Αρχείο προτύπου',
        browse: 'Περιήγηση',
        download_template: 'Λήψη προτύπου',
        no_file_selected: 'Δεν έχει επιλεγεί αρχείο',
        incorrect_file_type: 'Μη έγκυρος τύπος αρχείου',
        exceed: 'Υπέρβαση',
        upload_success: 'Επιτυχής μεταφόρτωση',
        upload_fail: 'Αποτυχία μεταφόρτωσης',
        again_upload:
            'Μπορείτε να μεταφορτώσετε μόνο εικόνες σε μορφές jpg, png, bmp ή gif. Παρακαλούμε δοκιμάστε ξανά.',
        attachmentUpload: 'Μεταφόρτωση συνημμένων',
        otherAttachmentUpload: 'Μεταφόρτωση άλλων συνημμένων',
        supportedFormats: 'Υποστηριζόμενες μορφές',
        preview: 'Προεπισκόπηση',
    },
    export: {
        noDataToExport: 'Δεν υπάρχουν δεδομένα για εξαγωγή',
    },
    select: {
        all: 'Όλα',
    },
    checkbox: {
        select_all: 'Επιλογή όλων',
    },
    dialog: {
        error_message: 'Μήνυμα σφάλματος',
        one_year: 'Μπορείτε να εξάγετε το πολύ δεδομένα ενός έτους',
    },
    ymd: {
        year: 'έτος',
        month: 'μήνας',
        day: 'ημέρα',
        week: 'εβδομάδα',
        january: 'Ιανουάριος',
        february: 'Φεβρουάριος',
        march: 'Μάρτιος',
        april: 'Απρίλιος',
        may: 'Μάιος',
        june: 'Ιούνιος',
        july: 'Ιούλιος',
        august: 'Αύγουστος',
        september: 'Σεπτέμβριος',
        october: 'Οκτώβριος',
        november: 'Νοέμβριος',
        december: 'Δεκέμβριος',
    },
};
